import {
  IconReportMoney,
  IconTruckReturn,
  IconShoppingCartPlus,
  IconShoppingCart,
  IconDashboard,
  IconCrown,
  IconCashBanknote,
  IconCoin,
  IconReportAnalytics,
  IconStorm,
  IconFileAnalytics,
  IconDotsCircleHorizontal,
  IconCategory,
  IconShieldLock,
  IconVectorBezierCircle,
  IconStack3,
} from "@tabler/icons";
// constant
const icons = {
  IconTruckReturn,
  IconShoppingCart,
  IconShoppingCartPlus,
  IconDashboard,
  IconCrown,
  IconCashBanknote,
  IconCoin,
  IconReportAnalytics,
  IconReportMoney,
  IconStorm,
  IconFileAnalytics,
  IconDotsCircleHorizontal,
  IconCategory,
  IconShieldLock,
  IconVectorBezierCircle,
  IconStack3,
};

const menuItems = [
  {
    id: "dashboard",
    title: "Dashboard",
    type: "group",
    url: "/",
    icon: icons.IconDashboard,
    breadcrumbs: false,

    condition: [
      {
        conditionTitle: "view",
        status: true,
      },
    ],
  },
  {
    id: "product",
    title: "Product",
    type: "group",
    url: "/product",
    ref: "inventory-product",
    icon: icons.IconDashboard,
    breadcrumbs: false,
    condition: [
      {
        conditionTitle: "view",
        status: true,
      },
      {
        conditionTitle: "create",
        status: true,
      },
      {
        conditionTitle: "update",
        status: true,
      },
      {
        conditionTitle: "delete",
        status: true,
      },
      {
        conditionTitle: "print",
        status: true,
      },
    ],
  },
  {
    id: "master",
    title: "Master",
    type: "group",
    url: "/master",
    icon: icons.IconDashboard,
    breadcrumbs: false,
    ref: "masters",
    condition: [
      {
        conditionTitle: "view",
        status: true,
      },
      {
        conditionTitle: "create",
        status: true,
      },
      {
        conditionTitle: "update",
        status: true,
      },
      {
        conditionTitle: "delete",
        status: true,
      },
      {
        conditionTitle: "print",
        status: true,
      },
    ],
  },
  {
    id: "accounts",
    title: "Accounts",
    type: "group",
    ref: "inventory-accounts",
    condition: [
      {
        conditionTitle: "view",
        status: true,
      },
      {
        conditionTitle: "create",
        status: true,
      },
      {
        conditionTitle: "update",
        status: true,
      },
      {
        conditionTitle: "delete",
        status: true,
      },
      {
        conditionTitle: "print",
        status: true,
      },
    ],
    children: [
      {
        id: "receipt",
        title: " Receipt",
        type: "item",
        url: "/accounts/receipt",
        icon: icons.IconReportMoney,
        breadcrumbs: false,
        ref: "inventory-accounts-receipt",
        condition: [
          {
            conditionTitle: "view",
            status: true,
          },
          {
            conditionTitle: "create",
            status: true,
          },
          {
            conditionTitle: "update",
            status: true,
          },
          {
            conditionTitle: "delete",
            status: true,
          },
          {
            conditionTitle: "print",
            status: true,
          },
        ],
      },
      {
        id: "payment",
        title: "Payment",
        type: "item",
        url: "/accounts/payment",
        icon: icons.IconFileAnalytics,
        breadcrumbs: false,
        ref: "inventory-accounts-payment",
        condition: [
          {
            conditionTitle: "view",
            status: true,
          },
          {
            conditionTitle: "create",
            status: true,
          },
          {
            conditionTitle: "update",
            status: true,
          },
          {
            conditionTitle: "delete",
            status: true,
          },
          {
            conditionTitle: "print",
            status: true,
          },
        ],
      },
    ],
  },
  {
    id: "sales",
    title: "Sales",
    type: "group",
    ref: "inventory-sales",
    condition: [
      {
        conditionTitle: "view",
        status: true,
      },
      {
        conditionTitle: "create",
        status: true,
      },
      {
        conditionTitle: "update",
        status: true,
      },
      {
        conditionTitle: "delete",
        status: true,
      },
      {
        conditionTitle: "print",
        status: true,
      },
    ],
    children: [
      {
        id: "sales-pos",
        title: "Sales B2B",
        type: "item",
        url: "/sales/salesPos",
        icon: icons.IconReportMoney,
        breadcrumbs: false,
        ref: "inventory-sales-b2b",
        condition: [
          {
            conditionTitle: "view",
            status: true,
          },
          {
            conditionTitle: "create",
            status: true,
          },
          {
            conditionTitle: "update",
            status: true,
          },
          {
            conditionTitle: "delete",
            status: true,
          },
          {
            conditionTitle: "print",
            status: true,
          },
        ],
      },
      {
        id: "sales-posb2c",
        title: "Sales B2C",
        type: "item",
        url: "/sales/salesPosb2c",
        icon: icons.IconReportMoney,
        breadcrumbs: false,
        ref: "inventory-sales-b2c",
        condition: [
          {
            conditionTitle: "view",
            status: true,
          },
          {
            conditionTitle: "create",
            status: true,
          },
          {
            conditionTitle: "update",
            status: true,
          },
          {
            conditionTitle: "delete",
            status: true,
          },
          {
            conditionTitle: "print",
            status: true,
          },
        ],
      },
      {
        id: "salesReturn",
        title: "Sales Return",
        type: "item",
        url: "/sales/salesReturn",
        icon: icons.IconTruckReturn,
        breadcrumbs: false,
        ref: "inventory-sales-return",
        condition: [
          {
            conditionTitle: "view",
            status: true,
          },
          {
            conditionTitle: "create",
            status: true,
          },
          {
            conditionTitle: "update",
            status: true,
          },
          {
            conditionTitle: "delete",
            status: true,
          },
          {
            conditionTitle: "print",
            status: true,
          },
        ],
      },
      {
        id: "salesReturnB2C",
        title: "Sales ReturnB2C",
        type: "item",
        ref: "inventory-sales-return-b2c",
        url: "/sales/salesReturnB2C",
        icon: icons.IconTruckReturn,
        breadcrumbs: false,
        condition: [
          {
            conditionTitle: "view",
            status: true,
          },
          {
            conditionTitle: "create",
            status: true,
          },
          {
            conditionTitle: "update",
            status: true,
          },
          {
            conditionTitle: "delete",
            status: true,
          },
          {
            conditionTitle: "print",
            status: true,
          },
        ],
      },
      {
        id: "orderForm",
        title: "Quotation ",
        type: "item",
        ref: "inventory-sales-order-form",
        url: "/sales/orderForm",
        icon: icons.IconTruckReturn,
        breadcrumbs: false,
        condition: [
          {
            conditionTitle: "view",
            status: true,
          },
          {
            conditionTitle: "create",
            status: true,
          },
          {
            conditionTitle: "update",
            status: true,
          },
          {
            conditionTitle: "delete",
            status: true,
          },
          {
            conditionTitle: "print",
            status: true,
          },
        ],
      },
      {
        id: "orderList",
        title: "POS ",
        type: "item",
        ref: "inventory-sales-pos",
        url: "pos/section",
        icon: icons.IconTruckReturn,
        breadcrumbs: false,
        condition: [
          {
            conditionTitle: "view",
            status: true,
          },
          {
            conditionTitle: "create",
            status: true,
          },
          {
            conditionTitle: "update",
            status: true,
          },
          {
            conditionTitle: "delete",
            status: true,
          },
          {
            conditionTitle: "print",
            status: true,
          },
        ],
      },
      {
        id: "orderListB2C",
        title: "POS B2C ",
        type: "item",
        ref: "inventory-sales-pos-b2c",
        url: "pos/sectionB2C",
        icon: icons.IconTruckReturn,
        breadcrumbs: false,
        condition: [
          {
            conditionTitle: "view",
            status: true,
          },
          {
            conditionTitle: "create",
            status: true,
          },
          {
            conditionTitle: "update",
            status: true,
          },
          {
            conditionTitle: "delete",
            status: true,
          },
          {
            conditionTitle: "print",
            status: true,
          },
        ],
      },
    ],
  },
  {
    id: "purchases",
    title: "Purchases",
    ref: "inventory-purchases",
    type: "group",
    condition: [
      {
        conditionTitle: "view",
        status: true,
      },
      {
        conditionTitle: "create",
        status: true,
      },
      {
        conditionTitle: "update",
        status: true,
      },
      {
        conditionTitle: "delete",
        status: true,
      },
      {
        conditionTitle: "print",
        status: true,
      },
    ],
    children: [
      {
        id: "purchase",
        title: "Purchase",
        type: "item",
        ref: "inventory-purchases-purchase",
        url: "/purchase/purchasebill",
        icon: icons.IconShoppingCartPlus,
        breadcrumbs: false,
        condition: [
          {
            conditionTitle: "view",
            status: true,
          },
          {
            conditionTitle: "create",
            status: true,
          },
          {
            conditionTitle: "update",
            status: true,
          },
          {
            conditionTitle: "delete",
            status: true,
          },
          {
            conditionTitle: "print",
            status: true,
          },
        ],
      },
      {
        id: "purchaseRetrun",
        title: "Purchase Return",
        type: "item",
        ref: "inventory-purchases-purchase-return",
        url: "/purchase/purchasebillReturn",
        icon: icons.IconTruckReturn,
        breadcrumbs: false,
        condition: [
          {
            conditionTitle: "view",
            status: true,
          },
          {
            conditionTitle: "create",
            status: true,
          },
          {
            conditionTitle: "update",
            status: true,
          },
          {
            conditionTitle: "delete",
            status: true,
          },
          {
            conditionTitle: "print",
            status: true,
          },
        ],
      },
      {
        id: "purchaseImport",
        title: "Purchase Import",
        type: "item",
        ref: "inventory-purchases-purchase-import",
        url: "/purchase/purchaseImport",
        icon: icons.IconTruckReturn,
        breadcrumbs: false,
        condition: [
          {
            conditionTitle: "view",
            status: true,
          },
          {
            conditionTitle: "create",
            status: true,
          },
          {
            conditionTitle: "update",
            status: true,
          },
          {
            conditionTitle: "delete",
            status: true,
          },
          {
            conditionTitle: "print",
            status: true,
          },
        ],
      },
      {
        id: "purchaseOrder",
        title: "Purchase Order",
        type: "item",
        ref: "inventory-purchases-purchase-order",
        url: "/purchase/PurchaseOrder",
        icon: icons.IconTruckReturn,
        breadcrumbs: false,
        condition: [
          {
            conditionTitle: "view",
            status: true,
          },
          {
            conditionTitle: "create",
            status: true,
          },
          {
            conditionTitle: "update",
            status: true,
          },
          {
            conditionTitle: "delete",
            status: true,
          },
          {
            conditionTitle: "print",
            status: true,
          },
        ],
      },
    ],
  },
  {
    id: "reports",
    title: "Reports",
    type: "group",
    ref: "inventory-reports",
    condition: [
      {
        conditionTitle: "view",
        status: true,
      },
      {
        conditionTitle: "create",
        status: true,
      },
      {
        conditionTitle: "update",
        status: true,
      },
      {
        conditionTitle: "delete",
        status: true,
      },
      {
        conditionTitle: "print",
        status: true,
      },
    ],
    children: [
      // {
      //     id: 'GST-Reports',
      //     title: 'GST Reports',
      //     type: 'item',
      //     url: '/reports/gst',
      //     icon: icons.IconCoin,
      //     breadcrumbs: false
      // },
      {
        id: "VAT-Reports",
        title: "VAT Reports",
        type: "item",
        url: "/reports/vat",
        ref: "inventory-reports-vat",
        icon: icons.IconCashBanknote,
        breadcrumbs: false,
        condition: [
          {
            conditionTitle: "view",
            status: true,
          },
          {
            conditionTitle: "create",
            status: true,
          },
          {
            conditionTitle: "update",
            status: true,
          },
          {
            conditionTitle: "delete",
            status: true,
          },
          {
            conditionTitle: "print",
            status: true,
          },
        ],
      },
      {
        id: "Sales-Report",
        title: "Sales Report",
        type: "item",
        ref: "inventory-reports-sales",
        url: "/reports/SalesReport",
        icon: icons.IconReportMoney,
        breadcrumbs: false,
        condition: [
          {
            conditionTitle: "view",
            status: true,
          },
          {
            conditionTitle: "create",
            status: true,
          },
          {
            conditionTitle: "update",
            status: true,
          },
          {
            conditionTitle: "delete",
            status: true,
          },
          {
            conditionTitle: "print",
            status: true,
          },
        ],
      },
      {
        id: "SalesReturn-Report",
        title: "SalesReturn Report",
        type: "item",
        url: "/reports/SalesReturnReport",
        icon: icons.IconFileAnalytics,
        breadcrumbs: false,
        ref: "inventory-reports-salesreturn",
        condition: [
          {
            conditionTitle: "view",
            status: true,
          },
          {
            conditionTitle: "create",
            status: true,
          },
          {
            conditionTitle: "update",
            status: true,
          },
          {
            conditionTitle: "delete",
            status: true,
          },
          {
            conditionTitle: "print",
            status: true,
          },
        ],
      },
      {
        id: "Purchase-Report",
        title: "Purchase Report",
        type: "item",
        ref: "inventory-reports-purchase",
        url: "/reports/PurchaseReport",
        icon: icons.IconFileAnalytics,
        breadcrumbs: false,
        condition: [
          {
            conditionTitle: "view",
            status: true,
          },
          {
            conditionTitle: "create",
            status: true,
          },
          {
            conditionTitle: "update",
            status: true,
          },
          {
            conditionTitle: "delete",
            status: true,
          },
          {
            conditionTitle: "print",
            status: true,
          },
        ],
      },
      {
        id: "Stock-Report",
        title: "Stock Report",
        type: "item",
        url: "/reports/Stock",
        icon: icons.IconTruckReturn,
        breadcrumbs: false,
        ref: "inventory-reports-stock",
        condition: [
          {
            conditionTitle: "view",
            status: true,
          },
          {
            conditionTitle: "create",
            status: true,
          },
          {
            conditionTitle: "update",
            status: true,
          },
          {
            conditionTitle: "delete",
            status: true,
          },
          {
            conditionTitle: "print",
            status: true,
          },
        ],
      },
      {
        id: "Batch-WiseStock-Report",
        title: "Batch Wise Stock Report",
        type: "item",
        url: "/reports/BatchWiseStock",
        icon: icons.IconTruckReturn,
        breadcrumbs: false,
        ref: "inventory-reports-batch-wise-stock",
        condition: [
          {
            conditionTitle: "view",
            status: true,
          },
          {
            conditionTitle: "create",
            status: true,
          },
          {
            conditionTitle: "update",
            status: true,
          },
          {
            conditionTitle: "delete",
            status: true,
          },
          {
            conditionTitle: "print",
            status: true,
          },
        ],
      },
      {
        id: "Bill-Wise-Profit-Report",
        title: "Bill Wise Profit Report",
        type: "item",
        url: "/reports/BillWiseProfitReport",
        icon: icons.IconTruckReturn,
        breadcrumbs: false,
        ref: "inventory-reports-bill-wise-profit",
        condition: [
          {
            conditionTitle: "view",
            status: true,
          },
          {
            conditionTitle: "create",
            status: true,
          },
          {
            conditionTitle: "update",
            status: true,
          },
          {
            conditionTitle: "delete",
            status: true,
          },
          {
            conditionTitle: "print",
            status: true,
          },
        ],
      },
      {
        id: "inventory-reports-employee-item-wise-sales-report",
        title: "Employee & Item Wise Sales report",
        type: "item",
        url: "/reports/employeeitemwisesalesreport",
        icon: icons.IconTruckReturn,
        breadcrumbs: false,
        ref: "inventory-reports-employee-item-wise-sales-report",
        condition: [
          {
            conditionTitle: "view",
            status: true,
          },
          {
            conditionTitle: "create",
            status: true,
          },
          {
            conditionTitle: "update",
            status: true,
          },
          {
            conditionTitle: "delete",
            status: true,
          },
          {
            conditionTitle: "print",
            status: true,
          },
        ],
      },

      {
        id: "inventory-reports-warehouse",
        title: "Warehouse Wise report",
        type: "item",
        url: "/reports/warehouseReport",
        icon: icons.IconTruckReturn,
        breadcrumbs: false,
        ref: "inventory-reports-warehouse",
        condition: [
          {
            conditionTitle: "view",
            status: true,
          },
          {
            conditionTitle: "create",
            status: true,
          },
          {
            conditionTitle: "update",
            status: true,
          },
          {
            conditionTitle: "delete",
            status: true,
          },
          {
            conditionTitle: "print",
            status: true,
          },
        ],
      },
      {
        id: "inventory-reports-warehouse",
        title: "Warehouse Transfer report",
        type: "item",
        url: "/reports/warehouseTransferReport",
        icon: icons.IconTruckReturn,
        breadcrumbs: false,
        ref: "inventory-reports-warehouse",
        condition: [
          {
            conditionTitle: "view",
            status: true,
          },
          {
            conditionTitle: "create",
            status: true,
          },
          {
            conditionTitle: "update",
            status: true,
          },
          {
            conditionTitle: "delete",
            status: true,
          },
          {
            conditionTitle: "print",
            status: true,
          },
        ],
      },
      {
        id: "inventory-reports-employeewise",
        title: "Employee Wise report",
        type: "item",
        url: "/reports/employeewisereport",
        icon: icons.IconTruckReturn,
        breadcrumbs: false,
        ref: "inventory-reports-employeewise",
        condition: [
          {
            conditionTitle: "view",
            status: true,
          },
          {
            conditionTitle: "create",
            status: true,
          },
          {
            conditionTitle: "update",
            status: true,
          },
          {
            conditionTitle: "delete",
            status: true,
          },
          {
            conditionTitle: "print",
            status: true,
          },
        ],
      },

      {
        id: "inventory-reports-cashflow",
        title: "Cash Flow Report",
        type: "item",
        url: "/reports/CashFlowReport",
        icon: icons.IconTruckReturn,
        breadcrumbs: false,
        ref: "inventory-reports-cashflow",
        condition: [
          {
            conditionTitle: "view",
            status: true,
          },
          {
            conditionTitle: "create",
            status: true,
          },
          {
            conditionTitle: "update",
            status: true,
          },
          {
            conditionTitle: "delete",
            status: true,
          },
          {
            conditionTitle: "print",
            status: true,
          },
        ],
      },
      {
        id: "inventory-reports-profit-loss",
        title: "Profit & Loss Report",
        type: "item",
        url: "/reports/ProfitLossReport",
        icon: icons.IconReportAnalytics,
        breadcrumbs: false,
        ref: "inventory-reports-profit-loss",
        condition: [
          {
            conditionTitle: "view",
            status: true,
          },
          {
            conditionTitle: "create",
            status: true,
          },
          {
            conditionTitle: "update",
            status: true,
          },
          {
            conditionTitle: "delete",
            status: true,
          },
          {
            conditionTitle: "print",
            status: true,
          },
        ],
      },
      {
        id: "inventory-reports-hot-sale",
        title: "Hot Sale Report",
        type: "item",
        url: "/reports/HotSaleReport",
        icon: icons.IconReportAnalytics,
        breadcrumbs: false,
        ref: "inventory-reports-hot-sale",
        condition: [
          {
            conditionTitle: "view",
            status: true,
          },
          {
            conditionTitle: "create",
            status: true,
          },
          {
            conditionTitle: "update",
            status: true,
          },
          {
            conditionTitle: "delete",
            status: true,
          },
          {
            conditionTitle: "print",
            status: true,
          },
        ],
      },
    ],
  },
  {
    id: "warehouseTransfer",
    title: "W.Transfer",
    type: "group",
    url: "/others/warehouseTransfer",
    ref: "inventory-warehouse-transfer",
    icon: icons.IconTruckReturn,
    breadcrumbs: false,
    condition: [
      {
        conditionTitle: "view",
        status: true,
      },
      {
        conditionTitle: "create",
        status: true,
      },
      {
        conditionTitle: "update",
        status: true,
      },
      {
        conditionTitle: "delete",
        status: true,
      },
      {
        conditionTitle: "print",
        status: true,
      },
    ],
  },
  {
    id: "setup",
    title: "Setup",
    type: "group",
    ref: "inventory-setup",
    condition: [
      {
        conditionTitle: "view",
        status: true,
      },
      {
        conditionTitle: "create",
        status: true,
      },
      {
        conditionTitle: "update",
        status: true,
      },
      {
        conditionTitle: "delete",
        status: true,
      },
      {
        conditionTitle: "print",
        status: true,
      },
    ],
    children: [
      {
        id: "category/subcategory",
        title: "Category/Sub",
        type: "item",
        ref: "inventory-setup-category-sub",
        url: "/others/createcategory",
        icon: icons.IconBrandAsana,
        breadcrumbs: false,
        condition: [
          {
            conditionTitle: "view",
            status: true,
          },
          {
            conditionTitle: "create",
            status: true,
          },
          {
            conditionTitle: "update",
            status: true,
          },
          {
            conditionTitle: "delete",
            status: true,
          },
          {
            conditionTitle: "print",
            status: true,
          },
        ],
      },

      // {
      //   id: "userPrivilege",
      //   title: "User Privilege",
      //   type: "item",
      //   url: "/others/userPrivilege",
      //   icon: icons.IconBrandAsana,
      //   breadcrumbs: false,
      //   condition: [
      //     {
      //       conditionTitle: "view",
      //       status: true,
      //     },
      //     {
      //       conditionTitle: "create",
      //       status: true,
      //     },
      //     {
      //       conditionTitle: "update",
      //       status: true,
      //     },
      //     {
      //       conditionTitle: "delete",
      //       status: true,
      //     },
      //     {
      //       conditionTitle: "print",
      //       status: true,
      //     },
      //   ],
      // },
      {
        id: "taxUtilities",
        title: "Tax Utilities",
        type: "item",
        ref: "inventory-setup-tax-utilities",
        url: "/others/taxUtilities",
        icon: icons.IconBrandAsana,
        breadcrumbs: false,
        condition: [
          {
            conditionTitle: "view",
            status: true,
          },
          {
            conditionTitle: "create",
            status: true,
          },
          {
            conditionTitle: "update",
            status: true,
          },
          {
            conditionTitle: "delete",
            status: true,
          },
          {
            conditionTitle: "print",
            status: true,
          },
        ],
      },
      {
        id: "CurrencyRate",
        title: "Currency Rate",
        type: "item",
        ref: "inventory-setup-currency-rate",
        url: "/others/CurrencyRate",
        icon: icons.IconBrandAsana,
        breadcrumbs: false,
        condition: [
          {
            conditionTitle: "view",
            status: true,
          },
          {
            conditionTitle: "create",
            status: true,
          },
          {
            conditionTitle: "update",
            status: true,
          },
          {
            conditionTitle: "delete",
            status: true,
          },
          {
            conditionTitle: "print",
            status: true,
          },
        ],
      },

      {
        title: "Void Bill Entry",
        type: "item",
        ref: "inventory-setup-void-bill-entry",
        url: "/others/voidbillentry",
        icon: icons.IconBrandAsana,
        breadcrumbs: false,
        condition: [
          {
            conditionTitle: "view",
            status: true,
          },
          {
            conditionTitle: "create",
            status: true,
          },
          {
            conditionTitle: "update",
            status: true,
          },
          {
            conditionTitle: "delete",
            status: true,
          },
          {
            conditionTitle: "print",
            status: true,
          },
        ],
      },
      {
        id: "invoiceSettings",
        title: "Invoice Settings",
        type: "collapse",
        ref: "inventory-setup-invoice-settings",
        icon: icons.IconBrandAsana,
        condition: [
          {
            conditionTitle: "view",
            status: true,
          },
        ],
        icon: icons.IconBrandAsana,
        children: [
          {
            title: "Printer setup",
            type: "item",
            ref: "inventory-setup-printer-setup",
            url: "/others/printersetup",
            icon: icons.IconBrandAsana,
            breadcrumbs: false,
            condition: [
              {
                conditionTitle: "view",
                status: true,
              },
              {
                conditionTitle: "create",
                status: true,
              },
              {
                conditionTitle: "update",
                status: true,
              },
              {
                conditionTitle: "delete",
                status: true,
              },
              {
                conditionTitle: "print",
                status: true,
              },
            ],
          },
          {
            id: "invoiceControls",
            title: "Invoice controls",
            type: "item",
            ref: "inventory-setup-invoice-controls",
            url: "/others/invoicecontrols",
            icon: icons.IconBrandAsana,
            breadcrumbs: false,
            condition: [
              {
                conditionTitle: "view",
                status: true,
              },
              {
                conditionTitle: "create",
                status: true,
              },
              {
                conditionTitle: "update",
                status: true,
              },
              {
                conditionTitle: "delete",
                status: true,
              },
              {
                conditionTitle: "print",
                status: true,
              },
            ],
          },
        ],
      },
    ],
  },
];
export default menuItems;
